export default __webpack_public_path__ + "static/media/OVIT.83901a26.png";